import Vue from 'vue';
import Router from 'vue-router';

import ModerationRefs from '@/pages/ModerationRefs';
import Moderation from '@/pages/Moderation';
import Statistic from '@/pages/Statistic';
import Greeting from '@/pages/Greeting';
import Upload from '@/pages/Upload';
import Rate from '@/pages/Rate';

import ServerError from '@/pages/ServerError';
import ErrorPage from '@/pages/ErrorPage';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Greeting',
      component: Greeting,
    },
    {
      path: '/rate/:slug',
      name: 'Rate',
      component: Rate,
    },
    {
      path: '/Uploads/:user',
      name: 'Statistic',
      component: Statistic,
    },
    {
      path: '/accounts/:user',
      name: 'Statistic',
      component: Statistic,
    },
    {
      path: '/moderate/:category',
      name: 'Moderation',
      component: Moderation,
    },
    {
      path: '/refs',
      name: 'ModerationRefs',
      component: ModerationRefs,
    },
    {
      path: '/refs/:category',
      name: 'ModerationRefs',
      component: ModerationRefs,
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload,
    },
    {
      path: '/404',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/500/',
      name: 'ServerError',
      component: ServerError,
    },
    {
      path: '*',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/:tag/accounts/:user',
      name: 'Statistic',
      component: Statistic,
    },
    {
      path: '/:tag',
      name: 'Greeting',
      component: Greeting,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js